import { type StateType } from '../../../states';
import { type EntitiesMulti } from '../../../states/entities/multi';
import { type Selector } from '../../../types/selectors';
import { selectEntitiesState } from '../entitiesPrimary.selector';

export const selectEntitiesMultiState: Selector<EntitiesMulti | null | undefined> = (state: StateType) =>
  selectEntitiesState(state)?.multi;

export const selectEntitiesMultiMatches: Selector<Array<number> | undefined> = (state: StateType) =>
  selectEntitiesMultiState(state)?.matches;

export const selectEntitiesMultiSports: Selector<Array<number> | undefined> = (state: StateType) =>
  selectEntitiesMultiState(state)?.sports;

export const selectEntitiesMultiCategories: Selector<Array<number> | undefined> = (state: StateType) =>
  selectEntitiesMultiState(state)?.categories;

export const selectEntitiesMultiTournaments: Selector<Array<number> | undefined> = (state: StateType) =>
  selectEntitiesMultiState(state)?.tournaments;
